import {
  INFO_TEXT_CURRENT_RISK,
  INFO_TEXT_POPULATION_AVERAGE_RISK,
  INFO_TEXT_POTENTIAL_RISK,
} from '@/constants/info-text';
import { formatRiskRound } from '@/utils';
import { Box, Flex, Grid, Text } from '@cmpsr/components';
import RiskAnalysisCardItem from './components/risk-analysis-card-item/risk-analysis-card-item';

type RiskAnalysisCardProps = {
  currentRisk: number;
  potentialRisk: number;
  averageRisk: number;
  badgeStyle: {
    bgColor: string;
    color: string;
    text: string;
  };
};

export default function RiskAnalysisCard(props: RiskAnalysisCardProps) {
  return (
    <Box
      border="1px solid"
      borderColor="medBlue"
      borderRadius="radii-3"
      py={{ base: 5, lg: 7 }}
      px={{ base: 5, lg: 6 }}
      data-testid="risk-analysis-card"
    >
      <Grid gridTemplateColumns="1fr 1fr 1fr" gap={5}>
        <RiskAnalysisCardItem
          title={
            <Flex flexDir="column">
              <Text variant="text-body-meta-regular" color="tan">
                Current{' '}
              </Text>
              <Text variant="text-body-meta-regular" color="tan">
                Lifetime{' '}
              </Text>
              <Text variant="text-body-meta-regular" color="tan">
                Risk
              </Text>
            </Flex>
          }
          value={formatRiskRound(props.currentRisk, 'overall')}
          popoverContent={INFO_TEXT_CURRENT_RISK}
          badgeBgColor={props.badgeStyle.bgColor}
          badgeTextColor={props.badgeStyle.color}
        />
        <RiskAnalysisCardItem
          title={
            <Flex flexDir="column">
              <Text variant="text-body-meta-regular" color="tan">
                Potential{' '}
              </Text>
              <Text variant="text-body-meta-regular" color="tan">
                Lifetime{' '}
              </Text>
              <Text variant="text-body-meta-regular" color="tan">
                Risk
              </Text>
            </Flex>
          }
          value={formatRiskRound(props.potentialRisk, 'overall')}
          popoverContent={INFO_TEXT_POTENTIAL_RISK}
          badgeBgColor="gradient.linear"
          badgeTextColor="text-primary-negative"
        />
        <RiskAnalysisCardItem
          title={
            <Flex flexDir="column">
              <Text variant="text-body-meta-regular" color="tan">
                Population{' '}
              </Text>
              <Text variant="text-body-meta-regular" color="tan">
                Lifetime{' '}
              </Text>
              <Text variant="text-body-meta-regular" color="tan">
                Risk
              </Text>
            </Flex>
          }
          value={formatRiskRound(props.averageRisk)}
          popoverContent={INFO_TEXT_POPULATION_AVERAGE_RISK}
          badgeBgColor="darkBlue"
          badgeTextColor="text-primary-negative"
        />
      </Grid>
    </Box>
  );
}
